module.exports = __webpack_public_path__ + "assets/menu-icon.c0aef1b1.svg";